import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { Language } from '@qtek/shared/models';
import { translationCoreInitialState } from '../models/translation-core.model';

export const TranslationCoreStore = signalStore(
  { providedIn: 'root' },
  withState(translationCoreInitialState),
  withMethods(store => ({
    mergeTranslations(
      translations: Record<string, string>,
      lang?: Language
    ): void {
      patchState(store, state => {
        const translationLang = lang ?? state.lang;
        return {
          translations: {
            ...state.translations,
            [translationLang]: {
              ...(state.translations?.[translationLang] ?? {}),
              ...translations,
            },
          },
        };
      });
    },
    setTranslations(
      translations: Record<Language, Record<string, string>>
    ): void {
      patchState(store, { translations });
    },
    setLanguage(lang: Language): void {
      patchState(store, { lang });
    },
    setVersion(version: string): void {
      patchState(store, { version });
    },
  }))
);
